import { HttpRequest, HttpMethod, axiosInstance } from "./http";

// Affiliate payout rounds (Phase 3 spec 2026-10-13 §3.8) — role
// affiliate_finance only. Errors: draft_exists, nothing_to_pay, not_draft,
// stale, has_paid_items, already_paid, not_submitted, slip_required, not_paid,
// no_slip. CSVs are UTF-8 BOM blobs.
const BASE = "/api/v1/bo/affiliate/payouts";

class AffiliatePayoutProvider extends HttpRequest {
    // ?status=&page=
    list(params) {
        return this.request(HttpMethod.Get, BASE, params);
    }
    // ?cutoff_date=YYYY-MM-DD → {eligible_count, total_gross, total_wht, total_net, skipped:{below_min, profile_not_verified, on_hold}}
    preview(cutoffDate) {
        return this.request(HttpMethod.Get, `${BASE}/preview`, { cutoff_date: cutoffDate });
    }
    // {cutoff_date, note} → PayoutDetail (draft)
    create(payload) {
        return this.request(HttpMethod.Post, BASE, payload);
    }
    get(id) {
        return this.request(HttpMethod.Get, `${BASE}/${id}`);
    }
    removeItem(id, itemId) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/items/${itemId}/remove`, {});
    }
    // {expected_updated_at}
    submit(id, payload) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/submit`, payload);
    }
    // {reason}
    cancel(id, payload) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/cancel`, payload);
    }
    // multipart: payment_date, slip, payment_note
    payItem(id, itemId, formData) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/items/${itemId}/pay`, formData);
    }
    // {reason}
    unpayItem(id, itemId, payload) {
        return this.request(HttpMethod.Post, `${BASE}/${id}/items/${itemId}/unpay`, payload);
    }
    // {data:{url, expires_in:300}}
    slipUrl(id, itemId) {
        return this.request(HttpMethod.Get, `${BASE}/${id}/items/${itemId}/slip-url`);
    }
    transferCsv(id) {
        return axiosInstance.get(`${BASE}/${id}/transfer.csv`, { responseType: "blob" });
    }
    whtCsv(id) {
        return axiosInstance.get(`${BASE}/${id}/wht.csv`, { responseType: "blob" });
    }
}

export default AffiliatePayoutProvider;
